import React, { useEffect, useState } from 'react';
import ButtonItem from './ResourceCard';
import { useGetBookChapterResourcesMutation } from '../../api/books';
import AssetsButtonShimmer from '../common/shimmers/ResourceButtonShimmer';
import NoAssetsScreen from '../../pages/errorPages/NoAssets';
import { RootState } from '../../store';
import { useSelector } from 'react-redux';

interface ResourceListProp {
    usm_id: string;
    all_videos: boolean;
    first_page: string;
    last_page: string;
    book_name: string;
    bookId: string;
}
interface ResourceConfigItem {
    res_type: string;
    displayName: string;
    icon: string;
    visibleToRoles: string[];
    visibleToProducts: string[];
    action: {
        default: string;
    };
    action_when_file_not_found: {
        default: string;
    };
    modal?: {
        buttonText: string;
        description: string;
        link: string;
        showRedirectButton: boolean;
        title: string;
    };
}
const ResourceList: React.FC<ResourceListProp> = ({
    usm_id,
    all_videos,
    first_page,
    last_page,
    book_name,
    bookId,
}) => {
    const [resources, setResources] = useState<any>([]);
    const [bookUri, setBookUri] = useState<string>('');
    const [opsPath, setOpsPath] = useState<string>('');
    const user = useSelector((state: RootState) => state.auth.user);
    const product = useSelector((state: RootState) => state.product) as
        | 'Buildr'
        | 'ActiveTeach';
    const productType = useSelector(
        (state: RootState) => state.SchoolInfo.data.product
    );
    const userRole = user?.rolename ? user?.rolename : 'Teacher';
    const resourceConfigLookup = useSelector(
        (state: RootState) => state.ResourceConfig.resourceConfigLookup
    );
    const [getBookChapterResources, { isLoading, isError }] =
        useGetBookChapterResourcesMutation();

    useEffect(() => {
        getBookChapterResources({
            usm_id: usm_id,
            first_page: first_page,
            last_page: last_page,
            book_name: book_name,
            book_id: bookId,
        }).then((res) => {
            if (res?.data?.success) {
                const filtered_resource_data = res?.data?.data?.resources
                    .map((resource: any) => {
                        // Retrieve the corresponding resource config based on res_type_name
                        const current_resource_config =
                            resourceConfigLookup[resource.res_type_name];

                        // If a matching config exists, check visibility criteria
                        if (current_resource_config) {
                            const isVisibleToProduct =
                                current_resource_config.visibleToProducts.includes(
                                    product === 'Buildr'
                                        ? 'Buildr'
                                        : productType
                                );
                            const isVisibleToRole =
                                current_resource_config.visibleToRoles.includes(
                                    userRole
                                );
                            // const fileFound = resource.file_name ? true : false;
                            // let showFileNotFoundAction = false;
                            // if (!fileFound) {
                            //     showFileNotFoundAction =
                            //         current_resource_config
                            //             .action_when_file_not_found.default !=
                            //         'hide'
                            //             ? true
                            //             : false;
                            // }
                            // Return resource only if it matches both visibility conditions
                            return isVisibleToProduct &&
                                isVisibleToRole &&
                                current_resource_config?.action.default !=
                                    'hide'
                                ? resource
                                : null;
                        }

                        // If no config exists, return the resource as is
                        return resource;
                    })
                    .filter((resource: any) => resource !== null); // Filter out null values
                setResources(filtered_resource_data);
                setBookUri(res?.data?.data?.book_uri);
                setOpsPath(res?.data?.data?.baseFolder);
            }
        });
    }, [usm_id, first_page, last_page, book_name, all_videos, bookId]);

    if (isLoading) {
        return <AssetsButtonShimmer />;
    }

    if (isError) {
        return <NoAssetsScreen />;
    }

    const filteredResources = all_videos
        ? resources.filter((obj: any) => obj?.extension === 'mp4')
        : resources;
    if (filteredResources.length === 0 && !isLoading) {
        return <NoAssetsScreen />;
    }

    return (
        <div className="flex flex-wrap mt-2">
            {filteredResources.map((obj: any) => (
                <ButtonItem
                    key={obj?.resource_id}
                    res_type={obj?.res_type_name || ''}
                    media_type={obj?.resourceType}
                    res_title={obj?.title}
                    res_id={obj?.resource_id?.toString()}
                    url={obj?.url}
                    book_uri={bookUri}
                    img_src={obj?.imgSrc}
                    ops_path={opsPath}
                    bookId={bookId}
                    resExtenstion={obj?.extension}
                    bookPageNum={obj?.pdf_page_num}
                    visualPageNum={obj?.page_num}
                />
            ))}
        </div>
    );
};

export default ResourceList;
